export default __webpack_public_path__ + "static/media/icon-close.961361e4.svg";